var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { api } from '../../services/api-client';
let JvAdminSites = class JvAdminSites extends LitElement {
    constructor() {
        super(...arguments);
        this._sites = [];
        this._loading = true;
        this._showForm = false;
        this._formName = '';
        this._formError = '';
        this._loadError = '';
        this._saving = false;
    }
    static { this.styles = css `
    :host { display: block; }
  `; }
    connectedCallback() {
        super.connectedCallback();
        void this._load();
    }
    async _load() {
        this._loading = true;
        this._loadError = '';
        try {
            this._sites = await api.get('/api/sites');
        }
        catch (err) {
            this._loadError = err?.message ?? 'Unable to load sites. Try again.';
        }
        finally {
            this._loading = false;
        }
    }
    async _handleCreate(e) {
        e.preventDefault();
        if (!this._formName.trim()) {
            this._formError = 'Name is required.';
            return;
        }
        this._saving = true;
        this._formError = '';
        try {
            await api.post('/api/sites', { name: this._formName.trim() });
            this._showForm = false;
            this._formName = '';
            await this._load();
        }
        catch (err) {
            this._formError = err?.message ?? 'Failed to create site.';
        }
        finally {
            this._saving = false;
        }
    }
    async _delete(id, name) {
        if (!confirm(`Delete site "${name}"?`))
            return;
        this._formError = '';
        try {
            await api.delete(`/api/sites/${id}`);
            this._sites = this._sites.filter(s => s.id !== id);
        }
        catch (err) {
            this._formError = err?.message ?? 'Cannot delete this site. Remove its cameras first.';
        }
    }
    _back() {
        this.dispatchEvent(new CustomEvent('admin-back', { bubbles: true, composed: true }));
    }
    render() {
        return html `
      <div class="max-w-content mx-auto px-5 sm:px-8 py-7">
        <div class="flex items-center gap-4 mb-6">
          <button @click=${this._back} class="text-sm text-jv-primary font-semibold hover:underline">&larr; Dashboard</button>
          <h1 class="text-2xl font-extrabold text-jv-ink">Sites</h1>
          <button @click=${() => this._showForm = !this._showForm}
            class="ml-auto jv-btn-primary text-xs px-4 py-2">
            ${this._showForm ? 'Cancel' : '+ Add Site'}
          </button>
        </div>

        ${this._formError ? html `<p class="text-jv-danger text-sm mb-4" role="alert">${this._formError}</p>` : ''}
        ${this._loadError ? html `<div class="jv-card p-6 mb-5" role="alert"><p class="text-jv-danger text-sm">${this._loadError}</p><button @click=${this._load} class="jv-btn-primary text-xs mt-4">Retry</button></div>` : ''}

        ${this._showForm ? html `
          <div class="jv-card mb-6"><div class="p-5">
            <h2 class="font-bold text-jv-ink mb-4">Add Site</h2>
            ${this._formError ? html `<p class="text-jv-danger text-sm mb-4">${this._formError}</p>` : ''}
            <form @submit=${this._handleCreate} class="flex gap-3">
              <input class="jv-input flex-1" .value=${this._formName} @input=${(e) => this._formName = e.target.value} placeholder="Main Building" />
              <button type="submit" ?disabled=${this._saving} class="jv-btn-primary shrink-0">${this._saving ? 'Adding…' : 'Add'}</button>
            </form>
          </div></div>
        ` : ''}

        ${this._loading ? html `<p class="text-jv-ink-2 text-sm">Loading…</p>` : html `
          ${this._sites.length === 0 ? html `
            <div class="jv-card"><div class="p-10 text-center"><p class="font-semibold text-jv-ink">No sites yet</p><p class="text-sm text-jv-ink-2 mt-1">Add a site (building) to organize cameras.</p></div></div>
          ` : html `
            <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              ${this._sites.map(s => html `
                <div class="jv-card p-4 flex items-center gap-3">
                  <span class="grid place-items-center w-10 h-10 rounded-xl bg-jv-primary-050 text-jv-primary shrink-0">
                    <svg viewBox="0 0 24 24" class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
                  </span>
                  <div class="flex-1 min-w-0">
                    <div class="font-bold text-sm text-jv-ink truncate">${s.name}</div>
                    ${s.cameraCount !== undefined ? html `<div class="text-xs text-jv-ink-2">${s.cameraCount} cameras</div>` : ''}
                  </div>
                  <button @click=${() => this._delete(s.id, s.name)}
                    class="text-xs text-jv-danger font-semibold hover:underline shrink-0">Delete</button>
                </div>
              `)}
            </div>
          `}
        `}
      </div>
    `;
    }
};
__decorate([
    state()
], JvAdminSites.prototype, "_sites", void 0);
__decorate([
    state()
], JvAdminSites.prototype, "_loading", void 0);
__decorate([
    state()
], JvAdminSites.prototype, "_showForm", void 0);
__decorate([
    state()
], JvAdminSites.prototype, "_formName", void 0);
__decorate([
    state()
], JvAdminSites.prototype, "_formError", void 0);
__decorate([
    state()
], JvAdminSites.prototype, "_loadError", void 0);
__decorate([
    state()
], JvAdminSites.prototype, "_saving", void 0);
JvAdminSites = __decorate([
    customElement('jv-admin-sites')
], JvAdminSites);
export { JvAdminSites };
